import React, { Component } from 'react';
import { Input, TextArea, Select } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';

import {
  ALL_OPTION,
  DATE_FORMAT_FOR_UI,
  DefaultTableState,
} from 'Common/Constants';
import { FieldEnum } from 'Common/FieldEnum';
import { AllOptionEnum } from './Constants/Enumeration/PropEnums';

moment.suppressDeprecationWarnings = true;

const buildTextWithoutIdDescriptionFun = (data) => {
  return caseInsensitiveSort(
    data.map((item) => {
      let text = item.Description;
      if (item.Id === 0 || item.Id === '0') {
        text = '';
      }
      return {
        value: item.Id,
        key: item.Id,
        text,
      };
    })
  );
};
const buildTextWithIdDescriptionFun = (data) => {
  return caseInsensitiveSort(
    data.map((item) => {
      let text = `${item.Id} ${item.Description}`;
      if (item.Id === 0 || item.Id === '0') {
        text = '';
      }
      return {
        value: item.Id,
        key: item.Id,
        text,
      };
    })
  );
};

export const truncateIfExceeds = (value, length) => {
  return value.substring(0, length);
};

export const minLengthPassword = 6;

export class renderField extends React.Component {
  ref = React.createRef();

  componentDidMount() {
    const { refCallback } = this.props;

    if (refCallback) {
      refCallback(this.ref);
    }
  }

  renderInput = () => {
    const {
      textAreaHeight,
      disabled,
      type,
      accept,
      autoFocus,
      options,
    } = this.props;

    switch (type) {
      case 'textarea':
        const height = (textAreaHeight || '200') + 'px';
        const areaStyle = {
          minWidth: '100%',
          height,
        };

        return (
          <TextArea
            style={areaStyle}
            className="form-control"
            ref={this.ref}
            {...this.props.input}
            disabled={disabled}
          />
        );
      case 'select':
        return (
          <Select
            value={this.props.input.value}
            ref={this.ref}
            onChange={(param, data) => this.props.input.onChange(data.value)}
            options={options}
          />
        );
      case 'file':
        return (
          <Input
            className="form-control"
            type={type}
            ref={this.ref}
            placeholder={this.props.placeholder}
            {...this.props.input}
            value={undefined}
            accept={accept === undefined ? '.csv, text/plain' : accept}
            disabled={disabled}
            maxLength={this.props.maxLength || 50}
            onChangeCapture={(e) => {
              const maxLength = this.props.maxLength || 50;
              if (e.target.value && e.target.value.length > maxLength) {
                e.target.value = e.target.value.substring(0, maxLength);
              }
            }}
          />
        );
      default:
        return (
          <Input>
            <input
              className="form-control"
              type={type}
              ref={this.ref}
              placeholder={this.props.placeholder}
              {...this.props.input}
              disabled={disabled}
              maxLength={this.props.maxLength || 50}
              onChangeCapture={(e) => {
                const maxLength = this.props.maxLength || 50;

                if (e.target.value && e.target.value.length > maxLength) {
                  e.target.value = e.target.value.substring(0, maxLength);
                }
              }}
              autoFocus={autoFocus}
            />
          </Input>
        );
    }
  };

  render() {
    const {
      meta: { touched, error, warning },
      type,
      label,
      reqdText,
    } = this.props;

    return (
      <div className={`input--type-${type}`}>
        {!label ? null : (
          <label>
            {label} {reqdText ? <span>{reqdText}</span> : null}{' '}
          </label>
        )}
        {this.renderInput()}
        {touched && error ? (
          <div className={'text-red input--message-error'}>{error}</div>
        ) : null}
        {touched && warning ? <div>{warning}</div> : null}
      </div>
    );
  }
}

/**
 * HOC used to extract the input props from redux form so that the normal
 * input can easily receive them in a HOC chain.
 */
export const FieldWithExtractedReduxActions = (InputComponent) => (props) => {
  const { input, ...rest } = props;
  return <InputComponent {...input} {...rest} />;
};

/**
 * Compnent must be used for input refs.
 * Stateless component not allowed!
 */
export class renderLargeField extends Component {
  inputRef = React.createRef();

  focus() {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  render() {
    const {
      meta: { touched, error, warning },
      attr = {},
      padBottom = true,
      label,
      maxLength = 50,
      ...rest
    } = this.props;

    // @todo remove inline styles
    const labelStyle = {
      textTransform: 'uppercase',
      color: '#555',
      fontSize: '14px',
      marginBottom: '3px',
    };

    // @todo remove inline styles
    return (
      <div style={{ marginBottom: padBottom ? '20px' : '0px' }}>
        <div style={labelStyle}>{label}</div>
        <div className="keyboard--input">
          <input
            className="loginInput"
            {...attr}
            maxLength={maxLength}
            ref={this.inputRef}
            {...rest}
          />
        </div>
        <span style={{ color: 'red' }}>
          {touched && error ? <div>{error}</div> : null}
          {touched && warning ? <div>{warning}</div> : null}
        </span>
      </div>
    );
  }
}

/**
 * @deprecated Isn't being used
 */
// export const sanitizeNumericInput = value => {
//   let newValue = value;

//   // Allow only digits and decimal.
//   newValue = newValue.replace(/[^\d.]/g, '');

//   // Limit to two decimal places.
//   newValue = newValue.replace(/\.(..).+/, '.$1');

//   // Fix double decimal points.
//   newValue = newValue.replace(/(\.\d)\./, '$1');
//   newValue = newValue.replace(/\.\./, '.');

//   // Cap at $99,999.
//   newValue = newValue.replace(/(\d{5})[^.]+/, '$1');

//   return newValue;
// };

export const listNames = (people, isAnd, locale) => {
  let names = Object.keys(people).map((personId) => {
    return people[personId][FieldEnum.FirstName];
  });

  let andOr = 'and';

  if (locale && locale.code === 'es') {
    if (isAnd) {
      andOr = 'y';
    } else {
      andOr = 'o';
    }
  } else if (!isAnd) {
    andOr = 'or';
  }

  if (names.length === 1) {
    return names[0];
  }

  if (names.length === 2) {
    return `${names[0]} ${andOr} ${names[1]}`;
  }

  if (names.length > 2) {
    let nameList = '';

    names.forEach((name, i) => {
      if (i === 0) {
        nameList = name;
      } else if (i === names.length - 1) {
        nameList = `${nameList} ${andOr} ${names[i]}`;
      } else {
        nameList = `${nameList}, ${names[i]}`;
      }
    });

    return nameList;
  }
};

export const isValidEmail = (value) =>
  value && !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/i.test(value)
    ? false
    : true;

export const isValidPhone = (value) => {
  if (value && !/\d{10}/.test(value)) {
    return false;
  }

  return true;
};

export const isValidURL = (value) => {
  let url = null;

  try {
    url = new URL(value);
  } catch (ex) {}

  return url !== null;
};

export const isDateValid = (value, format = DATE_FORMAT_FOR_UI, exact = true) =>
  moment(value, format, exact).isValid();

export const normalizeUnit = (value, previousValue) => {
  return value ? value.toUpperCase() : '';
};

export const normalizeNumeric = (value, previousValue) => {
  if (!value) {
    return '';
  }

  return value.replace(/[^\d]/g, '');
};

export const normalizePhone = (value, previousValue) => {
  if (!value) {
    return '';
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    if (onlyNums.length === 3) {
      return '(' + onlyNums + ') ';
    }
    if (onlyNums.length === 6) {
      return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3) + '-';
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
  }
  return (
    '(' +
    onlyNums.slice(0, 3) +
    ') ' +
    onlyNums.slice(3, 6) +
    '-' +
    onlyNums.slice(6, 10)
  );
};

export const normalizePhoneWithExtension = (value, previousValue) => {
  if (!value) {
    return '';
  }
  if (value.length <= 10) {
    const onlyNums = value.replace(/[^\d]/g, '');
    if (!previousValue || value.length > previousValue.length) {
      if (onlyNums.length === 3) {
        return '(' + onlyNums + ') ';
      }
      if (onlyNums.length === 6) {
        return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3) + '-';
      }
    }
    if (onlyNums.length <= 3) {
      return onlyNums;
    }
    if (onlyNums.length <= 6) {
      return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
    }
    return (
      '(' +
      onlyNums.slice(0, 3) +
      ') ' +
      onlyNums.slice(3, 6) +
      '-' +
      onlyNums.slice(6, 10)
    );
  } else {
    return value;
  }
};

export const formatDecimal = (places, preventNegative = true) => (value) => {
  if (isNaN(parseFloat(value)) || !isFinite(value)) {
    return '0.00';
  }

  //https://stackoverflow.com/a/46171960
  const splitString = value.toString().split('.');
  if (places <= 0) {
    return splitString[0];
  }
  let fractional = splitString[1] || '';
  if (fractional.length > places) {
    return `${splitString[0]}.${fractional.substr(0, places)}`;
  }
  while (fractional.length < places) {
    fractional += '0';
  }

  if (preventNegative) {
    splitString[0] = splitString[0].replace('-', '');
  }

  return `${splitString[0]}.${fractional}`;
};

export const formatDecimalShowZeroAsNull = (places) => (value) => {
  var parsed = parseFloat(value);
  if (isNaN(parsed)) {
    return null;
  }
  return parsed.toFixed(places);
};

export const formatToCash = formatDecimal(2);
export const formatToCashExtraPrecision = (digits) => formatDecimal(digits);
export const formatToCashAllowNegative = formatDecimal(2, false);

export const isEmpty = (value) => {
  return !value || (value && value.replace(/\s/g, '').length === 0);
};

export const formParseInt = (value) => {
  const parsed = parseInt(value, 10);

  return isNaN(parsed) ? value : parsed;
};

export const formParseDecimal = (value) => {
  const parsed = parseFloat(value);

  return isNaN(parsed) || parsed.toString().length < value.length
    ? value
    : parsed;
};

export const YesNoOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const makeOptionsWithNull = (
  data,
  options = {
    keyKey: 'Id',
    valueKey: 'Id',
    textKeys: ['Description'],
  },
  sortWith = caseInsensitiveSort
) => {
  return [
    {
      text: '',
      key: 'null',
      value: null,
    },
  ].concat(makeOptionsData(data, options, sortWith));
};

export const numericSort = (data) => {
  return _.sortBy(data, [(o) => Number(o.text)]);
};

export const caseInsensitiveSort = (data) => {
  data = _.sortBy(data, [(o) => o.text.toUpperCase()]);

  const foundALL = data.find(
    // look for any 'All' options
    (x) =>
      x.value === 0 &&
      x.key === 0 &&
      x.text.toUpperCase() === ALL_OPTION.toUpperCase()
  );

  if (foundALL) {
    const foundIndex = data.indexOf(foundALL);

    if (foundIndex > -1) {
      data.splice(foundIndex, 1);
    }

    data.splice(0, 0, { value: 0, key: 0, text: ALL_OPTION }); // Add 'All' to beginning of list
  }
  return data;
};

export const makeOptionsData = (
  data,
  options = {
    keyKey: 'Id',
    valueKey: 'Id',
    textKeys: ['Description'],
  },
  sortWith = caseInsensitiveSort
) => {
  if (data && Array.isArray(data) && data.length) {
    const mappedOptions = data.map((item) => ({
      value: item[options.valueKey],
      key: item[options.keyKey],
      text: options.textKeys.map((key) => item[key]).join(' '),
    }));
    return sortWith(mappedOptions);
  } else {
    return [];
  }
};

export const makeOptionsDataWithEmpty = (
  data,
  buildTextWithIdDescriptionFlag
) => {
  if (data && Array.isArray(data) && data.length) {
    let containZero = _.find(data, ['Id', 0]);
    if (!containZero) {
      containZero = _.find(data, ['Id', '0']);
    }
    !containZero &&
      data.splice(0, 0, {
        Description: '',
        Id: 0,
      });
    return buildTextWithIdDescriptionFlag
      ? buildTextWithIdDescriptionFun(data)
      : buildTextWithoutIdDescriptionFun(data);
  } else {
    return [];
  }
};
export const makeOptionsDataRemoveEmpty = (
  data,
  buildTextWithIdDescriptionFlag
) => {
  if (data && Array.isArray(data) && data.length) {
    let cloneData = _.clone(data);
    _.remove(cloneData, (n) => {
      return !n.Id || n.Id === '0';
    });
    return buildTextWithIdDescriptionFlag
      ? buildTextWithIdDescriptionFun(cloneData)
      : buildTextWithoutIdDescriptionFun(cloneData);
  } else {
    return [];
  }
};

export const makeMeasureOptions = (data) => {
  if (data && Array.isArray(data) && data.length) {
    return caseInsensitiveSort(
      data.map((item) => ({
        value: item.Id,
        key: item.Id,
        text: `${item.Measure}`,
      }))
    );
  } else {
    return [];
  }
};

export const makeUnitsOptions = (data, useSort = true) => {
  const options =
    data && data.length
      ? data.map((unit) => {
          return {
            value: unit,
            key: unit,
            text: unit,
          };
        })
      : [];

  if (useSort) {
    return caseInsensitiveSort(options);
  }

  return options;
};

export const makeUnitsOptionsWithNull = (data) => {
  return [
    {
      text: '',
      value: null,
      key: '',
    },
  ].concat(makeUnitsOptions(data));
};

export const makeMultiDropdownOptionsData = (data) => {
  if (data && Array.isArray(data) && data.length) {
    const copy = _.cloneDeep(data);
    copy.splice(0, 1);
    return caseInsensitiveSort(
      copy.map((item) => ({
        value: item.Id,
        key: item.Id,
        text: `${item.Description}`,
      }))
    );
  } else {
    return [];
  }
};

export const makeItemCodeFirstOptionsData = (data) => {
  if (data && Array.isArray(data) && data.length) {
    return caseInsensitiveSort(
      data.map((item) => ({
        value: item.Id,
        key: item.Id,
        text: item.ItemCode
          ? `${item.ItemCode}: ${item.Description}`
          : `${item.Description}`,
      }))
    );
  } else {
    return [];
  }
};

export const makeItemDescriptionFirstOptionsData = (data) => {
  if (data && Array.isArray(data) && data.length) {
    return caseInsensitiveSort(
      data.map((item) => ({
        value: item.Id,
        key: item.Id,
        text: item.ItemCode
          ? `${item.Description}: ${item.ItemCode}`
          : `${item.Description}`,
      }))
    );
  } else {
    return [];
  }
};

const createFriendlyText = (unfriendlyText) => {
  //turn pascal or camel case strings into friendly labels
  //ex. CEPTransferNotification -> CEP Transfer Notification
  const friendlyText = unfriendlyText.replace(
    //match either a lowercase letter that is followed by a non-lowercase
    //  letter (ex. fo(o)Bar) or an uppercase letter that is followed by a
    //  single uppercase letter and a non-uppercase letter (ex. FO(O)Bar)
    /([a-z](?=[^a-z\n])|[A-Z](?=[A-Z][^A-Z\n]))/g,
    (match) => match + ' '
  );

  return friendlyText;
};

export const makeButtonGroupOptionsFromEnum = (obj) => {
  const options = Object.entries(obj).map(([key, value]) => {
    let label = createFriendlyText(key);

    //make sure label starts with a capital letter
    label = label[0].toUpperCase() + label.substring(1);

    return { label, value };
  });

  return options;
};

export const makeSelectFieldOptionsFromEnum = (obj) => {
  const options = Object.entries(obj).map(([key, value]) => {
    let text = createFriendlyText(key);

    //make sure text starts with a capital letter
    text = text[0].toUpperCase() + text.substring(1);

    return { text, value, key: value };
  });

  return options;
};

export const getIds = (dataSource) => {
  return dataSource && dataSource.length
    ? dataSource.map((item) => {
        return item.Id;
      })
    : [];
};

export const normalizeZip4 = (value, previousValue) => {
  if (!value) {
    return '';
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    if (onlyNums.length === 5) {
      return onlyNums;
    }
    if (onlyNums.length === 10) {
      return onlyNums.slice(0, 5) + '-' + onlyNums.slice(5);
    }
  }
  if (onlyNums.length <= 5) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 5) + '-' + onlyNums.slice(5);
  }
  return onlyNums.slice(0, 5) + '-' + onlyNums.slice(5, 10);
};

export const TabDisabledInput = ({ filter, onChange }) => {
  return (
    <input
      tabIndex="-1"
      onChange={(event) => onChange(event.target.value)}
      value={filter ? filter.value : ''}
    />
  );
};

export const clearTableSavedState = (
  history,
  basicURL,
  allTableStates,
  setTableStates,
  tableNames
) => {
  if (history && _.has(history, 'location.pathname')) {
    const path = history.location.pathname;
    if (
      path &&
      (!basicURL || path.search(basicURL) === -1) &&
      typeof setTableStates === 'function' &&
      Array.isArray(tableNames)
    ) {
      const tableProps = tableNames.reduce(
        (o, k) => _.set(o, k, DefaultTableState),
        {}
      );
      setTableStates({
        ...allTableStates,
        ...tableProps,
      });
    }
  }
};

export const getDates = (disableStartDate) => {
  const minDate = moment().set('year', 1980);
  const maxDate = moment().add(10, 'year');
  let dateArray = [];
  let currentDate = minDate;
  while (currentDate <= maxDate) {
    dateArray.push(moment(currentDate).endOf('month'));
    disableStartDate && dateArray.push(moment(currentDate).startOf('month'));
    currentDate = moment(currentDate).add(1, 'month');
  }
  return dateArray;
};

export const makeWarehouseSiteIdOptions = (data) => {
  return data.map((item) => {
    let text = `${item.Id}: ${item.Description}`;
    if (item.Id === 0 || item.Id === '0') {
      text = '';
    }
    return {
      value: item.Id,
      WarehouseSiteId: item.Id,
      text,
    };
  });
};

export const getInventoryValue = (onHandItems) => {
  const items = onHandItems && onHandItems.length ? onHandItems : [];
  return items
    .reduce((total, d) => {
      return total + Number(d.Value);
    }, 0)
    .toFixed(4);
};

export const NUMBER = 'NUMBER';

/**
 * Handler that can be passed to redux-form's onSubmitFail. It will scroll to the
 * first error.
 *
 * @param {Object} errors
 * @param {String} scrollContainerId - the scroll container's id
 * @param {Number} yOffset - amount of spacing between the top of the screen and input element when scrolled to
 */
export const scrollToFirstError = (errors = {}, scrollContainerId, yOffset) => {
  let firstError = null;

  for (const field of Object.keys(errors)) {
    if (Array.isArray(errors[field])) {
      const errorList = errors[field];

      for (const [i, errorObj] of errorList.entries()) {
        if (!errorObj) continue;
        const fields = Object.keys(errorObj);

        if (fields.length > 0) {
          firstError = `${field}[${i}].${fields[0]}`;
          break;
        }
      }

      if (firstError) {
        break;
      }
    } else {
      firstError = field;
      break;
    }
  }

  if (firstError) {
    const scrollContainer = document.getElementById(scrollContainerId);

    if (scrollContainer) {
      const el = document.querySelector(`[name="${firstError}"]`);

      if (el) {
        const containerTop = scrollContainer.getBoundingClientRect().top;
        const distanceFromViewportTop = Math.abs(
          window.pageYOffset - containerTop
        );

        const scrollOffset = scrollContainer.scrollTop;
        const elDistanceFromViewportTop = Math.abs(
          window.pageYOffset - el.getBoundingClientRect().top - scrollOffset
        );
        const elPositionRelativeToContainer = Math.abs(
          elDistanceFromViewportTop - distanceFromViewportTop
        );
        const scrollToPosition = elPositionRelativeToContainer - yOffset;

        scrollContainer.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth',
        });
      }
    }
  }

  return firstError;
};

export const scrollOnSubmitFail = (
  containerId = 'main-section',
  yOffset = 8
) => (errors) => scrollToFirstError(errors, containerId, yOffset);

export const makeOptionsDataWithAll = (data, ...args) =>
  (data && data.length > 0 ? [{ value: 0, key: -1, text: 'ALL' }] : []).concat(
    makeOptionsData(data, ...args)
  );

export const getLevelValue = (bracketPricingDetails, price) => {
  const levelArray = _.filter(bracketPricingDetails, function (o) {
    if (o.ToBracket && price >= o.FromBracket && price <= o.ToBracket) {
      return true;
    } else if (price >= o.FromBracket && o.ToBracket === null) {
      return true;
    }
  });
  if (levelArray.length > 0) {
    return levelArray[0].Price;
  } else {
    return price;
  }
};
export const dollarCalculation = (itemObj, level1, isGrid) => {
  if (itemObj.PriQty && !itemObj.SecQty) {
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(itemObj.PriQty * level1)
    );
    return isGrid ? levelValue : itemObj.PriQty * levelValue;
  } else if (itemObj.PriQty && itemObj.SecQty) {
    const purchase = +itemObj.SecQty / itemObj.QtyPerUnit;
    const price = (+itemObj.PriQty + purchase) * level1;
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(price)
    );
    return isGrid ? levelValue : (+itemObj.PriQty + purchase) * levelValue;
  } else if (!itemObj.PriQty && itemObj.SecQty) {
    const purchase = +itemObj.SecQty / itemObj.QtyPerUnit;
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(purchase * level1)
    );
    return isGrid ? levelValue : purchase * levelValue;
  }
  return isGrid ? +itemObj.BracketPricingDetails[0].Price : 0;
};

export const quantityCalculation = (itemObj, isGrid) => {
  if (itemObj.PriQty && !itemObj.SecQty) {
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(itemObj.PriQty)
    );
    return isGrid ? levelValue : itemObj.PriQty * levelValue;
  } else if (itemObj.PriQty && itemObj.SecQty) {
    const purchase = itemObj.SecQty / itemObj.QtyPerUnit;
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(+itemObj.PriQty + purchase)
    );
    return isGrid ? levelValue : (+itemObj.PriQty + purchase) * levelValue;
  } else if (!itemObj.PriQty && itemObj.SecQty) {
    const purchase = itemObj.SecQty / itemObj.QtyPerUnit;
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(purchase)
    );
    return isGrid ? levelValue : purchase * levelValue;
  }
  return isGrid ? +itemObj.BracketPricingDetails[0].Price : 0;
};

export const weightCalculation = (itemObj, isGrid) => {
  if (itemObj.PriQty && !itemObj.SecQty) {
    const purchaseQtyPerWeight =
      itemObj.QtyPerUnit * itemObj.SecondaryUnitWeight;
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(+itemObj.PriQty * purchaseQtyPerWeight)
    );
    return isGrid ? levelValue : +itemObj.PriQty * levelValue;
  } else if (itemObj.PriQty && itemObj.SecQty) {
    const purchase = itemObj.SecQty / itemObj.QtyPerUnit;
    const purchaseQtyPerWeight = itemObj.SecQty * itemObj.SecondaryUnitWeight;
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round((+itemObj.PriQty + purchase) * purchaseQtyPerWeight)
    );
    return isGrid ? levelValue : (+itemObj.PriQty + purchase) * levelValue;
  } else if (!itemObj.PriQty && itemObj.SecQty) {
    const purchase = itemObj.SecQty / itemObj.QtyPerUnit;
    const purchaseQtyPerWeight = itemObj.SecQty * itemObj.SecondaryUnitWeight;
    const levelValue = getLevelValue(
      itemObj.BracketPricingDetails,
      Math.round(purchase * purchaseQtyPerWeight)
    );
    return isGrid ? levelValue : purchase * levelValue;
  }
  return isGrid ? +itemObj.BracketPricingDetails[0].Price : 0;
};

/**
 * Formats the field name to human readable text
 * @example
 * formatName('MEAL_TYPE') // Meal Type
 * formatName('PRIMARY_SITE') // Primary Site
 */
const formatName = _.flow(_.snakeCase, _.startCase);

const defaultValidator = (value, values) => {
  let isValid = false;
  switch (typeof value) {
    case 'boolean': // if it's a boolean, it has a value
      isValid = true;
      break;
    case 'number':
    case 'bigint':
      isValid = value > 0;
      break;
    case 'string':
    case 'object':
    default:
      isValid = !_.isEmpty(value);
  }

  return isValid;
};

/**
 * Creates a validator that checks if these field names are entered
 * @param {Array<String>} fieldNames
 * @param {Object} customErrorMessages - custom error messages for the missing field
 * @param {Object} customValidators - custom validators for the field
 *
 * @example
 * const fields = [Fields.ItemId, Fields.SiteId]
 * const customErrorMessages = { [Fields.SiteId]: 'Site must be a primary site', [Fields.ItemId]: 'Serving Item is required'}
 * const customValidators = {
 *  [Fields.SiteId]: (value) => value['Id'] === value['PrimarySiteId']
 * }
 * const validator = createFieldsValidator(fields, errorMap)
 */
export const createFieldsValidator = (
  fieldNames = [],
  customErrorMessages = {},
  customValidators = {}
) => {
  /**
   * Checks if the form values have values for the field names
   * @param values - the form's current value
   * @returns {Object} errors
   */
  return (values) => {
    const errors = {};
    fieldNames.forEach((name) => {
      const value = values[name];

      const isValid = customValidators[name]
        ? customValidators && customValidators[name](value, values)
        : defaultValidator(value, values);

      if (!isValid) {
        errors[name] =
          customErrorMessages && customErrorMessages[name]
            ? customErrorMessages[name]
            : `${formatName(name)} is required.`;
      }
    });
    return errors;
  };
};

/**
 * Checks if the error object has any errors
 * @returns {Boolean}
 * @example
 * const errors = {};
 * hasFormErrors(errors); // false
 * const errors2 = { date: 'Please enter a date.' };
 * hasFormErrors(errors2); // true
 */
export const hasFormErrors = (errors) => {
  if (!errors) {
    return false;
  }
  /** Checks if the keys that are set have empty values */
  const filteredErrors = Object.values(errors).filter(
    (value) => !_.isNil(value)
  );

  return filteredErrors.length > 0;
};

export const buildYearsFromFiscalYears = (fiscalYears) => {
  let minYear = Math.min(...fiscalYears) - 1;
  const currentYear = new Date().getFullYear();
  const years = [];
  let count = 0;

  while (minYear <= currentYear) {
    years.push({ key: count, value: minYear, text: minYear.toString() });
    minYear += 1;
    count += 1;
  }
  years.sort((a, b) => (a.value < b.value ? 1 : -1));

  return years;
};

const DEFAULT_FROM_TO_VALIDATOR_OPTIONS = {
  granularity: 'day',
  fromName: 'From',
  toName: 'To',
  dateFormat: DATE_FORMAT_FOR_UI,
  strict: false,
};

/**
 * Validates the from/to values
 * @param {Moment|String|Date} fromValue
 * @param {Moment|String|Date} toValue
 * @param {Object} options
 * @param {String} options.granularity - Precision of the check, defaults to day
 * @param {String} options.fromName - From field name, defaults to 'From'
 * @param {String} options.fromLabel - From field label
 * @param {String} options.toName - To field name, defaults to 'To'
 * @param {String} options.toLabel - To field label
 * @param {String} options.dateFormat - date format to parse with
 * @param {Boolean} options.strict - value should follow the exact dateFormat specified
 */
export const rangeDateValidator = (fromValue, toValue, options) => {
  const opts = {
    ...DEFAULT_FROM_TO_VALIDATOR_OPTIONS,
    ...options,
  };

  const errors = {};

  const hasFromValue = Boolean(fromValue);
  const hasToValue = Boolean(toValue);
  const formattedFromName = formatName(opts.fromName);
  const formattedToName = formatName(opts.toName);

  const fromLabel = opts.fromLabel || formattedFromName;
  const toLabel = opts.toLabel || formattedToName;

  if (!hasFromValue) {
    errors[opts.fromName] = `${fromLabel} Date must be set.`;
  }

  if (!hasToValue) {
    errors[opts.toName] = `${toLabel} Date must be set.`;
  }

  if (hasFromValue && hasToValue) {
    const fromDate = moment(fromValue, opts.dateFormat, opts.strict);
    const toDate = moment(toValue, opts.dateFormat, opts.strict);

    if (!fromDate.isValid()) {
      errors[opts.fromName] = `Enter a valid ${fromLabel} Date.`;
    }

    if (!toDate.isValid()) {
      errors[opts.toName] = `Enter a valid ${toLabel} Date.`;
    }

    if (toDate.isValid() && fromDate.isValid()) {
      const toIsBeforeFrom = toDate.isBefore(fromDate, opts.granularity);
      if (toIsBeforeFrom) {
        errors[
          opts.fromName
        ] = `The ${toLabel} Date cannot be before the ${fromLabel} Date.`;
        errors[opts.toName] = errors[opts.fromName];
      }

      if (opts.yearLimit) {
        const yearDateDiff = toDate.diff(fromDate, 'years', true);
        if (yearDateDiff > opts.yearLimit) {
          errors[
            opts.fromName
          ] = `The date range cannot be greater than ${opts.yearLimit} year(s).`;
          errors[opts.toName] = errors[opts.fromName];
        }
      }

      if (opts.monthLimit) {
        const monthDateDiff = toDate.diff(fromDate, 'months', true);
        if (monthDateDiff > opts.monthLimit) {
          errors[
            opts.fromName
          ] = `The date range cannot be greater than ${opts.monthLimit} month(s).`;
          errors[opts.toName] = errors[opts.fromName];
        }
      }

      if (opts.dayLimit) {
        const dayDateDiff = toDate.diff(fromDate, 'days');
        if (dayDateDiff > opts.dayLimit) {
          errors[
            opts.fromName
          ] = `The date range cannot be greater than ${opts.dayLimit} day(s).`;
          errors[opts.toName] = errors[opts.fromName];
        }
      }
    }
  }

  return errors;
};

/**
 * Converts moment's custom date formats tokens to unicode token
 * https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {String} format
 * @returns {String}
 */
export const convertMomentToUnicode = (format) =>
  format
    .replace('YYYY', 'yyyy') // full year
    .replace(/\bDD\b/, 'dd') // day of month, short
    .replace('dddd', 'cccc'); // day of week, long

/**
 * Given an object of props, return an object where all moment objects have
 * been cast to Date objects
 * @param {object} props - Props object with possible moment objects
 * @returns {object} Props with moment objects cast to date objects
 */
export const convertMomentPropsToDateProps = (props) => {
  const dateProps = {};

  for (var name in props) {
    if (props.hasOwnProperty(name)) {
      const prop = props[name];

      if (Array.isArray(prop)) {
        dateProps[name] = prop.map((entry) =>
          entry instanceof moment ? entry.toDate() : entry
        );
      } else {
        dateProps[name] = prop instanceof moment ? prop.toDate() : prop;
      }
    }
  }

  return dateProps;
};

/**
 * Checks if string is base64 string
 * https://github.com/miguelmota/is-base64
 * @param {String} v
 * @param {Object} opts
 * @param {Boolean} opts.allowEmpty -  returns true for empty string
 * @param {Boolean} opts.allowMime - returns true for valid strings with optional mime
 * @param {Boolean} opts.mimeRequired - returns true for valid strings with mime
 * @param {Boolean} opts.paddingRequired -  returns true for valid strings with valid padding
 */
export const isBase64 = (v, opts) => {
  if (v instanceof Boolean || typeof v === 'boolean') {
    return false;
  }

  if (!(opts instanceof Object)) {
    opts = {};
  }

  if (opts.allowEmpty === false && v === '') {
    return false;
  }

  let regex =
    '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+/]{3}=)?';
  let mimeRegex = '(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)';

  if (opts.mimeRequired === true) {
    regex = mimeRegex + regex;
  } else if (opts.allowMime === true) {
    regex = mimeRegex + '?' + regex;
  }

  if (opts.paddingRequired === false) {
    regex =
      '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}(==)?|[A-Za-z0-9+\\/]{3}=?)?';
  }

  return new RegExp('^' + regex + '$', 'gi').test(v);
};

const dataUriRegex = new RegExp(
  // eslint-disable-next-line
  /^data:.+\/(.+);base64,(.*)$/
);
export const hasDataUri = (value) => dataUriRegex.test(value);

/**
 * Checks if string has a '.csv' suffix
 * @param {String} input
 */
export const hasCsvExtension = (input) => {
  return !/\.csv$/.test(input);
};

export const formatNumber = (value) => {
  if (_.isNil(value) || value === '') {
    return 0;
  }
  return Number(value);
};

/**
 * Given an object, returns the keys that are truthy
 * NOTE: will count empty Array, Object, Map, Set
 * @param {Object.<string, any>} object
 * @returns {string[]}
 *
 * @example
 *
 * extractTruthyKeys({a: true, b: false, c: true, d: true }) // ["a", "c", "d"]
 */
export const extractTruthyKeys = (object) =>
  Object.entries(object)
    .filter(([_, v]) => Boolean(v))
    .map(([k]) => k);

/**
 * Counts the number of truthy keys within the object
 *
 * @param {Object.<string, any>} object
 * @returns {number}
 */
export const countTruthyKeys = (object) => extractTruthyKeys(object).length;

/**
 * Add an 'ALL' option to a select options list.
 *
 * @param  {Object[]} options
 * @param  {AllOptionEnum} allOptionType
 *
 * @returns {array}
 */
export const addAllOption = (options, allOptionType = AllOptionEnum.All) => {
  if (allOptionType === AllOptionEnum.None) {
    return options;
  }

  return [
    allOptionType === AllOptionEnum.Zero
      ? { value: '0', text: 'All', key: '0' }
      : { value: 'ALL', text: 'ALL', key: 'valueALL' },
    ...options,
  ];
};

export const isPercentValid = (value) => {
  if (!value) return true;
  if (parseFloat(value) >= 0 && parseFloat(value) <= 100) return true;

  return false;
};



// WEBPACK FOOTER //
// ./src/common/FormHelper.js